import { getMonth } from "date-fns";

export default function (date: number | Date)
{
    return getMonth(date);
}